<div class="app_input w_100" *ngIf="inputData" [ngClass]="{disabled_input: inputData.disabled || inputData.readOnly}">
  <span class="label" *ngIf="!inputData.hiddenLabel" [hidden]="!inputData.data.value">{{(inputData.label || '') | translate}}</span>
  <input type="text"
         #input
         *ngIf="inputData.type !== 'textarea'"
         [readOnly]="inputData.readOnly"
         [required]="inputData.required==true"
         [pattern]="inputData.pattern || '.*'"
         [classList]="inputData.inputClass"
         [prefix]="inputData.prefix ? inputData.prefix : ''"
         [mask]=" inputData.prefix ? '(000)-000-00-00' : (inputData.mask ? inputData.mask : '')"
         [type]="inputData.type"
         [ngClass]="{hasValue: inputData.data.value && !inputData.hiddenLabel}"
         [disabled]="inputData.disabled == true"
         [(ngModel)]="inputData.data.value"
         [leadZeroDateTime]="inputData.leadZeroDateTime!"
         [placeholder]="(inputData.placeholder || '') | translate"
  >
  <textarea
    *ngIf="inputData.type === 'textarea'"
    [required]="inputData.required!"
    [pattern]="inputData.pattern!"
    [disabled]="inputData.disabled!"
    [(ngModel)]="inputData.data.value"
    [placeholder]="(inputData.placeholder || '') | translate"
  ></textarea>
  <img *ngIf="(inputData.disabled || inputData.readOnly) && !inputData.dontResetValueInClearAction" class="blocked_img" src="assets/images/icons/orders/blocked.svg">
  <img *ngIf="inputData.clickOnly && !inputData.addressSelection" class="blocked_img" src="assets/images/icons/arrow.svg">
  <div class="flex_align_center on_the_map" *ngIf="inputData.clickOnly && inputData.addressSelection">
    <span class="on_the_map--title">
      {{'orders.on_the_map' | translate}}
    </span>
    <img class="ml_8" src="assets/images/icons/order_creation_address_select_img.svg">
  </div>
  <img *ngIf="inputData.clearButton" class="blocked_img pointer" src="assets/images/icons/clear.svg"
       (click)="clearInputField($event)">
</div>


